import { CreateProjectButton } from '@/pages/video-studio/components/Header/CreateProjectButton';
import { Search } from '@/pages/video-studio/components/Header/Search';
import { useFlag } from '@/services/featureFlags';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const FeatureFlagsTest = styled.div`
    background-image: url('https://www.rollingstone.com/wp-content/uploads/2011/03/britneyspears.jpg?w=1500&h=1000&crop=1');
    display: flex;
    justify-content: center;
    background-position: center;
    background-size: contain;
    align-items: center;
    width: 200px;
    height: 44px;
    border-radius: 8px;
`;

export const Header = () => {
    const britneyEnabled = useFlag('test_feature_enabled', false);

    return (
        <Container>
            <Search />
            {britneyEnabled && (
                <FeatureFlagsTest>
                    <Typography variant="h6" color="#fff">
                        Just testing don't mind me
                    </Typography>
                </FeatureFlagsTest>
            )}

            <CreateProjectButton />
        </Container>
    );
};
